<template>
    <div>
        <div class="py-4">
            <h1 class="h2 text-regular">
                {{ $t('forgot.title') }}
            </h1>

            <p
                v-if="response.error"
                class="text-left error--text pt-4 text-smedium"
            >
                {{ response.error }}
            </p>

            <p
                class="pt-4 mb-0 text-left text-smedium"
            >
                <template v-if="response.data">
                    {{ $t('forgot.success') }}
                </template>

                <template v-else>
                    {{ $t('forgot.instructions') }}
                </template>
            </p>
        </div>

        <div class="py-4">
            <router-link
                v-if="response.data"
                :to="{name: $options.ROUTE.LOGIN}"
                class="text-left"
            >
                {{ $t('forgot.login') }}
            </router-link>

            <form-forgot
                v-else
                @success="onSuccess"
                @error="onError"
            ></form-forgot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            response: {
                error: null,
                data: null,
            },
        };
    },

    methods: {
        onError(response) {
            this.response.error = response;
        },
        onSuccess(response) {
            this.response.data = response;
        },
    },
};
</script>
